import 'chosen-js/chosen.css';

const globalStylesheets = require.context('./global', true, /\.(css|scss)$/);
globalStylesheets.keys().forEach(globalStylesheets);
